import React, { useState } from "react"
import { styled } from "../stitches.config"
import { Formik, Form, Field } from "formik"
import * as Yup from "yup"

const AdultGate = () => {
    const [isOver18, setIsOver18] = useState(null);

    const handleSubmit = (values) => {
        setIsOver18(values.confirmed);
    }

    return (
        <>
            {!isOver18 &&
                <Wrapper>
                    <Modal>
                        <h1>
                            Strona zawiera treści przeznaczone<br />dla osób pełnoletnich
                        </h1>
                        <p>Aby uzyskać dostęp, potwierdź że masz ukończone 18 lat</p>

                        <Formik
                            initialValues={{ confirmed: false }}
                            validationSchema={Yup.object().shape({
                                confirmed: Yup.boolean()
                                    .oneOf([true], "Musisz potwierdzić, że masz 18 lat, żeby wejść na tą stronę")
                                    .required()
                            })}
                            onSubmit={handleSubmit}
                        >
                            {({ isValid, dirty, errors, touched }) => (
                                <Form>
                                    <CheckboxWrapper>
                                        <Field
                                            type="checkbox"
                                            name="confirmed"
                                            id="confirmed"
                                        />
                                        <CheckboxLabel htmlFor="confirmed" error={errors.confirmed && touched.confirmed}>
                                            Mam ukończone 18 lat.
                                        </CheckboxLabel>
                                    </CheckboxWrapper>

                                    {errors.confirmed && touched.confirmed && (
                                        <Warning>{errors.confirmed}</Warning>
                                    )}

                                    <Button type="submit" disabled={!(isValid && dirty)}>
                                        Wejdź
                                    </Button>
                                </Form>
                            )}
                        </Formik>

                        <a href="//natemat.pl/info/polityka-prywatnosci">
                            Warunki korzystania ze strony oraz polityka prywatności
                        </a>
                    </Modal>
                </Wrapper>
            }
        </>
    )
}

const Modal = styled("div", {
    zIndex: 5000002,
    margin: "30px auto",
    maxWidth: "735px",
    padding: "48px",
    background: "#ffffff",
    "@media (max-width: 425px)": {
        padding: "32px 16px",
        height: "100%"
    },
    "h1": {
        color: "#000000",
        fontSize: "38px",
        fontWeight: 700,
        lineHeight: "42px",
        margin: "0 0 16px 0",
        "@mobile": {
            fontSize: "24px",
            lineHeight: "30px"
        }
    },
    "p": {
        color: "#131212",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "24px",
        "@bp4": {
            fontSize: "20px",
        }
    },
    "a": {
        display: "block",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "24px",
        marginTop: "49px",
        color: "#8D8D8D"
    }
});

const Button = styled("button", {
    display: "block",
    width: "173px",
    color: "#ffffff",
    borderRadius: "3px",
    padding: "13px 64px",
    marginTop: "30px",
    background: "#FF6400",
    transition: "background-color 300ms",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    border: "none",
    "&:disabled": {
        backgroundColor: "#bbb"
    }
});

const Warning = styled("div", {
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "18px",
    color: "#EA3A3E",
    marginTop: "20px"
});

const CheckboxWrapper = styled("div", {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginTop: "20px",
    input: {
        "@bp4": {
            width: "20px",
            height: "20px",
        }
    }
});

const CheckboxLabel = styled("label", {
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    "@bp4": {
        fontSize: "20px",
    },
    variants: {
        error: {
            true: {
                color: "#EA3A3E"
            },
            false: {
                color: "#131212"
            }
        }
    }
});

const Wrapper = styled("div", {
    backgroundColor: "#131212",
    position: "fixed",
    left: "0",
    top: "0",
    right: "0",
    bottom: "0",
    zIndex: 5000001,
    overflow: "auto",
    padding: "10px 0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "@media (max-width: 425px)": {
        padding: "0",
        background: "#ffffff"
    }
});

export default AdultGate;
